<template>
	<dl class="row">
		<dt :class="titleClass">Run ID:</dt>
		<dd :class="valueClass">{{ testRun.runId }}</dd>

		<dt :class="titleClass">Date:</dt>
		<dd :class="valueClass">{{ formattedDate }}</dd>

		<dt :class="titleClass">Executed By:</dt>
		<dd :class="valueClass">{{ testRun.userName }}</dd>

		<dt :class="titleClass">Total Duration:</dt>
		<dd :class="valueClass">{{ parsedDuration }}</dd>

		<dt :class="titleClass">Total Number Of Tests:</dt>
		<dd :class="valueClass">{{ testRun.startedTestsCount }}</dd>

		<dt :class="titleClass">Number Of Tests Executed:</dt>
		<dd :class="valueClass">{{ testRun.finishedTestsCount }}</dd>

		<dt :class="titleClass">Overall Status:</dt>
		<dd :class="[STATUS_CLASSES[testRun.status], valueClass]">
			{{testRun.status}}
			<template v-if="testRun.status===RUN_STATUS.RUNNING">
				<Loading />
				<button
					title="Stop"
					class="btn btn-danger"
					@click="cancelTestRun()"
				>
					<i class="fas fa-times"></i>
				</button>
			</template>
		</dd>
	</dl>
</template>
<script>

import { STATUS_CLASSES, RUN_STATUS } from '../../util/test-runner-constants';
import { convertDuration, formatDate } from '../../util/test-runner';
import Loading from '../shared/Loading';

export default {
	name: 'TestRunInfoPanel',
	props: ['testRun'],
	components: {
		Loading
	},
	created() {
		this.titleClass = "col-4";
		this.valueClass = "col-8";
		this.STATUS_CLASSES = STATUS_CLASSES;
		this.RUN_STATUS = RUN_STATUS;
	},
	computed: {
		parsedDuration() {
			return convertDuration(this.testRun.duration);
		},
		formattedDate() {
			return formatDate(this.testRun.startedAt, true)
		}
	},
	methods: {
		cancelTestRun() {
			this.$emit('cancelTestRun');
		}
	}
}
</script>
<style>
</style>